export { default } from './avatar'
export type { AvatarProps } from './avatar'
